import { dataLayerPushTag } from '../data-layer';
import { checkAndFormatEvent, isAnEcommerceEvent } from './utils';
export function trackEvent(event) {
    try {
        // Prevent double measures, and just drop these calls
        if ('ecommerce' in event && event.ecommerce === null) {
            return;
        }
        /* When there's an e-commerce event, make sure always to fire this event.
         * See Readme #1.4
         */
        if (isAnEcommerceEvent(event)) {
            dataLayerPushTag({ ecommerce: null }, 'track event - e-commerce precursor'); // Clear the previous ecommerce object.
        }
        const debugName = 'event' in event ? `track event - ${event.event}` : 'track event - not specified';
        dataLayerPushTag(checkAndFormatEvent(event), debugName);
    }
    catch (error) {
        console.error(error);
    }
}
